<template>
  <div style="margin: 20px;">
    <a-button type="primary" style="margin-bottom: 16px;">
      <router-link to="/mindmap/edit" style="color: #fff;">新建思维导图</router-link>
    </a-button>
    <a-table :columns="columns" :data-source="data" rowKey="id" :scroll="{ x: 800 }">
      <template #bodyCell="{ record, column }">
        <template v-if="column.dataIndex === 'title'">
          <router-link :to="`/mindmap?id=${record.id}`">{{ record.title }}</router-link>
        </template>
        <template v-if="column.dataIndex === 'created_at'">
          {{ formatDate(record.created_at) }}
        </template>
        <template v-if="column.dataIndex === 'updated_at'">
          {{ formatDate(record.updated_at) }}
        </template>
        <template v-if="column.key === 'operation'">
          <a @click="editMindMap(record)">编辑</a> |
          <a-popconfirm
            title="确定要将此思维导图移动到回收站吗？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="() => moveToTrash(record.id)"
          >
            <a style="color: #ff4d4f; cursor: pointer;">删除</a>
          </a-popconfirm>
        </template>
      </template>
    </a-table>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { getMindMapList, softDeleteMindMap } from '@/api/mindmap'
import { message } from 'ant-design-vue'

const router = useRouter()
const data = ref([])

const columns = [
  {
    title: '标题',
    dataIndex: 'title',
    key: 'title',
    width: '30%',
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    key: 'created_at',
    width: '20%',
  },
  {
    title: '更新时间',
    dataIndex: 'updated_at',
    key: 'updated_at',
    width: '20%',
  },
  {
    title: '操作',
    key: 'operation',
    width: 120,
  },
]

// 获取思维导图列表
async function fetchMindMapList() {
  try {
    const res = await getMindMapList()
    data.value = Array.isArray(res) ? res : res.data
  } catch (error) {
    message.error('获取思维导图列表失败：' + error.message)
  }
}

// 编辑
function editMindMap(item) {
  router.push(`/mindmap/edit/${item.id}`)
}

// 删除
async function moveToTrash(id) {
  try {
    await softDeleteMindMap(id)
    await fetchMindMapList()
    message.success('已移动到回收站')
  } catch (error) {
    message.error('操作失败：' + error.message)
  }
}

// 格式化日期
function formatDate(dateString) {
  const date = new Date(dateString)
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  })
}

onMounted(() => {
  fetchMindMapList()
})
</script>
